import type { ResourcesConfig } from 'aws-amplify';
import { z } from 'zod';

export const AmplifyConfigSchema = z
  .object({
    USER_POOL_ID: z.string(),
    USER_POOL_CLIENT_ID: z.string(),
  })
  .transform(
    ({ USER_POOL_ID, USER_POOL_CLIENT_ID }) =>
      ({
        Auth: {
          Cognito: {
            userPoolId: USER_POOL_ID,
            userPoolClientId: USER_POOL_CLIENT_ID,
          },
        },
      }) satisfies ResourcesConfig,
  );

export const authLogger = (message: string, extra?: unknown) => {
  if (process.env.NODE_ENV === 'test') return;

  // eslint-disable-next-line no-console
  console.log(...[`\n[AUTHENTICATION_UI] ${message}\n`, extra].filter(Boolean));
};
